export default __webpack_public_path__ + "static/media/07.3383c475.jpg";